/**
 * True iff the event type starts with `PATIENT_` — i.e. was authored by the patient.
 * Used to advance the patient's own eventSeqRead whenever they author a qualifying
 * event in a state update.
 *
 * @__NO_SIDE_EFFECTS__
 */
export function isPatientAuthoredEvent(event) {
    return event.type.startsWith('PATIENT_');
}
//# sourceMappingURL=isPatientAuthoredEvent.js.map